import {Component, input, output, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {SeFeModalButton, SeFeModalComponent, SeFeModalModule} from 'se-fe-modal';
import {Product} from '../../../../../models/clare';

@Component({
  selector: 'set-to-active-modal',
  imports: [SeFeModalModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './set-to-active-modal.component.html',
})
export class SetToActiveModalComponent {
  @ViewChild('setToActiveModal') setToActiveModal: SeFeModalComponent;

  /**
   * Products to set to active.
   */
  products = input<Product[]>([]);

  /**
   * Emitted when the user confirms setting all products to active.
   */
  setAllProductsToActive = output<Product[]>();

  modalButtons: SeFeModalButton[] = [
    {
      cancel: true,
      label: 'Cancel',
      action: () => {
        this.setToActiveModal.close();
      },
    },
    {
      primary: true,
      label: 'Set to active',
      action: () => {
        this.setToActiveModal.close();
        this.handleSetAllProductsToActive();
      },
      loadingLabel: 'Setting all products to active',
    },
  ];

  /**
   * Handles setting all products to active.
   * Emits the event to the parent component.
   */
  handleSetAllProductsToActive(): void {
    const products = this.products();
    if (products && products.length > 0) {
      this.setAllProductsToActive.emit(products);
    }
  }
}
